import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { FaHome } from "react-icons/fa";

const ExitBtn = styled(NavLink)`
  position: fixed;
  left: 2rem;
  top: 1.5rem;
  z-index: 10;
  font-size: calc(1.9rem + 2vw);
  color: ${(props) => `rgba(252, 246, 244, 0.7)`};
  text-decoration: none;
  cursor: pointer;

  @media (min-width: 1671px) {
    left: 4rem;
  }

  @media (max-width: 461px) {
    top: 0.9rem;
  }
`;

const Exit = () => {
  return (
    <ExitBtn to="/">
      <FaHome />
    </ExitBtn>
  );
};

export default Exit;
